import React, { useEffect } from "react";
import { useDisclosure } from "@mantine/hooks";
import { ExplanationModal } from "../../Components/System/Messages/ExplanationModal";
import { Terms } from "../Terms/Terms";

export const AcceptTerms = ({ termsAccepted, setTermsAccepted }) => {
    const [opened, { open, close }] = useDisclosure(false);

    return (
        <div className="mr-4 flex items-center">
            <div className="mr-2">
                <input 
                    type="checkbox"
                    checked={termsAccepted} 
                    onChange={(event) => setTermsAccepted(event.currentTarget.checked)}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                />
            </div>
            <div className="text-xs">
                I understand that my offers are binding and I agree to <span className="underline cursor-pointer" onClick={open}>Carzelles terms</span>
            </div>
            <ExplanationModal HelpComponent={<Terms showBorders={false} />} opened={opened} close={close} title="Terms" />
        </div>
    )
};